// Permission check for Parent-App ERP staff pages. Mirrors the gating logic
// already used by ParentAppSidebar.tsx (nav items are hidden without the
// right permission) and the backend's hasPermission bypass rules in
// pa-rbac.middleware.js — so a page-level action button and its nav entry
// never disagree about who's allowed to see it.
//
// undefined permissions (CRM-embed login, no permission data available) =>
// unrestricted, matching today's behavior for that login path; null
// (super_admin/bootstrap) => unrestricted too.

export function getPaPermissions(): string[] | null | undefined {
  try {
    const rawErp = localStorage.getItem('erp_user');
    if (rawErp) {
      const u = JSON.parse(rawErp);
      return u?.permissions ?? null;
    }
  } catch {
    /* fall through */
  }
  return undefined;
}

export function hasPaPermission(module: string, action: string = 'view'): boolean {
  const permissions = getPaPermissions();
  if (permissions === null || permissions === undefined) return true;
  return permissions.includes(`${module}.${action}`);
}
